import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsQuizCreate } from '@/learnpaths/components/LearnpathsAddElementsQuizCreate/LearnpathsAddElementsQuizCreate'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(quiz)/create/quiz',
)({
  component: RouteComponent,
  validateSearch: (search: { index?: number }) => search,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsQuizCreate {...params} />
}
